import { MEETING_MANAGER_PREPARATION_WITH_CAREER_PATH_EVALUATION } from '../MeetingQueries'
import { ApolloError, useQuery } from '@apollo/client'
import { MeetingManagerPreparationQuery, MeetingManagerPreparationQueryVariables } from '../../../types'

export const useMeetingManagerPreparation = (
  meetingId: string,
): {
  data: MeetingManagerPreparationQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<MeetingManagerPreparationQuery, MeetingManagerPreparationQueryVariables>(
    MEETING_MANAGER_PREPARATION_WITH_CAREER_PATH_EVALUATION,
    {
      variables: {
        meetingId: meetingId,
      },
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
